'use client';
import { useAppDispatch, useAppSelector } from '@/store/store';
import { fetchMeta } from '@/store/brokerMetricsHandlers';
import { Suspense, useEffect } from 'react';
import BrokerMetrics from './BrokerMetrics';
import LoadingSpinner from './UI/LoadingSpinner';

function Home() {
    const dispatch = useAppDispatch();
    const metaLoaded = useAppSelector((state) => state.brokerMetrics.metaLoaded);

    useEffect(() => {
        dispatch(fetchMeta());
    }, [dispatch]);

    return (
        <Suspense fallback={<div className='text-8xl'>Loading...</div>}>
            <div>{metaLoaded ? <BrokerMetrics /> : <LoadingSpinner />}</div>
        </Suspense>
    );
}

export default Home;
